import { ReactNode } from 'react';

import {
  SummaryCardsCarousel,
  SummaryCardSlot,
} from '@/modules/common/components/molecules/summary-cards-carousel';

interface OverheadsSummaryCardsRowProps {
  children: ReactNode;
}

/**
 * Overheads-flavored aliases of the shared summary-cards snap carousel
 * (extracted to `@/modules/common/components/molecules/summary-cards-carousel`
 * when the approvals page adopted the same layout).
 */
export const OverheadsSummaryCardsRow = ({ children }: OverheadsSummaryCardsRowProps) => (
  <SummaryCardsCarousel>{children}</SummaryCardsCarousel>
);

/** Fixed-width snap slot for one summary card. */
export const OverheadsSummaryCardSlot = ({ children }: { children: ReactNode }) => (
  <SummaryCardSlot>{children}</SummaryCardSlot>
);
